import { useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import { admin_permission_detail, make_payout, list_failed_payout } from "../../../api/apiHandler";
import DataTable from "react-data-table-component";
import FontAwesome from "react-fontawesome";
import Swal from "sweetalert2";
import SwalOld from "sweetalert"
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { CButton, CFormInput, CInputGroup } from "@coreui/react";
import customStyles from "../../../utils/dataTableStyles";
import useDebounce from "../../../utils/useDebounce";

export default function FailedPayout({ isLoader }) {

    // const [data, setData] = useState([{"count":1,"full_name":"test","email":"mitg@hyperlinkinfosystem.com","country_name":"India","payout_amount":1,"current_status": "Pending", "is_payout" : 0},{"count":2,"full_name":"test user","email":"testuser@gmail.com","country_name":"USA","payout_amount":1,"current_status": "In-Progress", "is_payout" : 0},{"count":3,"full_name":"user test","email":"usertest@gmail.com","country_name":"Afganistan","payout_amount":1,"current_status": "Failed", "is_payout" : 0}])
    const [data, setData] = useState([])
    const AdminId = localStorage.getItem("aID")
    const [permissions, setPermission] = useState([]);
    const role = localStorage.getItem("adminRole");
    const [search, setSearch] = useState('')
    const debounceSearch = useDebounce(search, 750);

    const handleGetData = () => {
        isLoader(true)
        list_failed_payout({ search: search }).then((response) => {
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setData(dataWithRowCount);
                isLoader(false)
            } else {
                setData([])
                isLoader(false)
            }
        })
    }

    const manualPayout = (id) => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to do manual payout?",
            showCancelButton: true,
            confirmButtonText: "Yes do it",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    // return;
                    isLoader(true)
                    console.log('id: ', id);
                    make_payout({"pay_id" : id}).then((response) => {
                        if (response.code == "1") {
                            TOAST_SUCCESS(response.message);
                            handleGetData();
                            isLoader(false)
                        } else {
                            TOAST_ERROR(response.message);
                            isLoader(false)
                        }
                    })
                } catch (error) {
                    TOAST_ERROR("Error..!!");
                }
            }
        });
    }

    const subAdminPermission = () => {
        admin_permission_detail({ id: AdminId })
            .then((response) => {
                if (response.code == 1) {
                    setPermission(response.data);
                } else {
                    setPermission([])
                }
            })
            .catch((error) => {
                setPermission([])
            });
    }

    useEffect(() => {
        handleGetData();
        if (role !== "S") {
            subAdminPermission();
        }
    }, [debounceSearch])

    const categoryPermission = permissions.find(permission => permission.menu_name === "Categories");

    // Check if status is allowed for "Categories"
    const isStatusAllowed = categoryPermission && categoryPermission.status === 1;

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            // width: "140px"
        },
        {
            name: 'Full name',
            selector: row => row.full_name,
            sortable: true,
            // width: "140px"
            
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            // width: "250px"
        },
        {
            name: 'Country',
            selector: row => row.country_name,
            sortable: true,
            // width: "140px"
        },
        {
            name: 'Amount',
            selector: row => `${row.payout_amount} ${row.payout_currency?.toUpperCase()}`,
            sortable: true,
            // width: "140px"
        },
        {
            name: 'Status',
            selector: row => row.current_status,
            sortable: true,
            // width: "140px"
        },
        {
            name: 'Payment Initiated On',
            selector: row => row?.payment_initiated_date || "",
            sortable: true,
            // width: "140px"
        },
        {
            name: 'Payment Response On',
            selector: row => row?.payment_response_date || "",
            sortable: true,
            // width: "140px"
        },
        {
            name: 'Status',
            selector: row => row.current_status,
            sortable: true,
            // width: "140px"
        },
        {
            name: role == "S" || isStatusAllowed ? 'Action' : '',
            cell: (row) => (
                // <div className="d-flex justify-content-center">
                <>
                    {(role === "S" || isStatusAllowed) && (
                        <button onClick={() => manualPayout(row.id)} className="btn-theme bg-yellow cursor-pointer" disabled={row.is_payout != 0}
                        >Payout</button>
                    )}
                </>
                // </div>
            ),
        },
    ]

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <>
                    <div className="fs-3 fw-500 mt-4 ms-4 mb-1">
                        Failed Payout
                    </div>
                    <div className="px-5 mt-1">
                        <div className="d-flex justify-content-end align-items-center mb-3 search-container">
                            <div className="row me-2">
                                <div className="col">
                                    <CInputGroup>
                                        <CFormInput type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                                        <CButton style={{ backgroundColor: "rgb(87, 8, 97)", color: "light" }}>
                                            <FontAwesome className="fa-solid fa-search" name="search" />
                                        </CButton>
                                    </CInputGroup>
                                </div>
                            </div>
                        </div>
                        <div>
                            {(data && data.length > 0 ? (
                                <DataTable columns={columns} data={data} pagination customStyles={customStyles} />
                            ) : (
                                <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No Data Found</p>
                            )
                            )}
                        </div>
                    </div>
                </>
            </div>
        </main>
    </>
}